import React, { useEffect, useState } from 'react'
import DisplayStocks from '../components/dataDisplay/DisplayStocks'
import { clearSelectedShop } from '../store/shopSlice'
import { useDispatch } from 'react-redux'

export default function StockGeneral() {
  const [visible, setVisible] = useState(false)
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(clearSelectedShop()) // Call the action
    setVisible(true) // Set visibility after dispatch
  }, [dispatch])

  return (
    <div>
      {visible && <DisplayStocks />}
    </div>
  )
}
